import { SideNav, SideNavContent } from "components";
import UploadFile from "components/UploadFile";
import {
  LargeButton,
  MainBody,
  OverlayLoader,
  PageTitle,
} from "components/core";
import React, { useState } from "react";
import http from "services/httpService";
import routes from "components/routes";
import { useNavigate } from "react-router";

const MasterDoc = () => {
  const navigate = useNavigate();
  const [fileError, setFileError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fileId, setFileId] = useState();
  const showSidebar = () => {
    return (
      !!localStorage.getItem("id") && !!localStorage.getItem("gmc_details")
    );
  };

  const handleSubmit = async (values) => {
    const prevSuperTaskId = localStorage.getItem("super_task_id");
    if(prevSuperTaskId) {
      const payload = {
        params: {
          super_task_id: prevSuperTaskId,
        },
      };
      const { data } = await http.get("business/get_taskset_details/", payload);
      const tasks = data.task_set_data.async_tasks;
      const isPending = tasks.some(task => task.status.toLowerCase() === "pending");
      if(isPending) {
        alert("The previous task is in pending state. Please wait until task has been fulfilled.");
        return;
      }
    }
    
    const flow = sessionStorage.getItem("flex_setup_type");
    if (!fileId) {
      setFileError(true);
      return;
    }
    const payload = {
      upload_flow: flow ? flow : "setup",
      master_sheet_id: fileId,
      page: "master"
    };
    try {
      setIsLoading(true);
      const { data } = await http.post(
        "business/employee_data_upload_pre_issuance/",
        payload
      );
      localStorage.setItem("super_task_id", data.super_task_id);
      navigate({
        pathname: `/${routes.FLEX_PENDING_STATE}`,
        state: { flow: flow },
      })
    } catch (ex) {
      alert("Something went wrong");
      console.log(ex.response.data, "at parent components");
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <section>
          <SideNav>{showSidebar() && <SideNavContent />}</SideNav>
          <MainBody>
            <section>
              <PageTitle title="Upload Master Employee Data" />
              <section style={{ maxWidth: "800px" }}>
                <UploadFile
                  text="Upload Excel"
                  sampleFile="MasterEmployeeSheet"
                  format="excel"
                  type="employees_excel"
                  onSelect={(id) => setFileId(id)}
                  showError={fileError}
                />
                <LargeButton
                  label="Save & Next"
                  onClick={handleSubmit}
                  style={{
                    padding: "1.8rem 0rem",
                    position: "absolute",
                    maxWidth: "800px",
                    bottom: "32px",
                  }}
                />
              </section>
            </section>
          </MainBody>
        </section>
      )}
    </>
  );
};

export default MasterDoc;
